import CreatableReactSelect from 'react-select/creatable';
import createSelect from './createSelect';
var CreatableSelect = createSelect(CreatableReactSelect);
export default CreatableSelect;